/**
 * Storage
 * handles getting and setting storage values
 */

const PREFIX = "player.";

export const StorageKey = {
  VOLUME: "volume",
  VOLUME_PREVIEW: "volume_preview",
  MUTED: "muted",
  MUTED_PREVIEW: "muted_preview",
};

function prefix(key: string): string {
  return `${PREFIX}${key}`;
}

function deserialize(value: string | null): unknown {
  if (value) {
    try {
      return JSON.parse(value) ?? undefined;
    } catch (_e) {
      console.warn("Failed to parse invalid JSON data", value);
    }
  }
}

function serialize(value: unknown): string | undefined {
  try {
    return JSON.stringify(value) || undefined;
  } catch (_e) {
    //
  }
}

/********************
 * Persistent storage
 ********************/

/**
 * Get value based on key
 */
export function getData<T = unknown>(key: string): T | undefined {
  return (deserialize(localStorage.getItem(prefix(key))) as T) ?? undefined;
}

/**
 * Set value on key
 */
export function setData(key: string, value: unknown) {
  const serialized: string | undefined = serialize(value);
  if (serialized === undefined) {
    removeData(key);
  } else {
    localStorage.setItem(prefix(key), serialized);
  }
}

/**
 * Remove value for key
 */
export function removeData(key: string) {
  localStorage.removeItem(prefix(key));
}

/*******************
 * Transient storage
 *******************/

export function getSessionData<T = unknown>(key: string): T | undefined {
  return (deserialize(sessionStorage.getItem(prefix(key))) as T) ?? undefined;
}

export function setSessionData(key: string, data: unknown) {
  const serialized: string | undefined = serialize(data);
  if (serialized === undefined) {
    removeSessionData(key);
  } else {
    sessionStorage.setItem(prefix(key), serialized);
  }
}

export function removeSessionData(key: string) {
  sessionStorage.removeItem(prefix(key));
}
